/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-23 22:52:25
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-16 11:28:45
 * @FilePath: /goldenSalesMobile/src/api/user.js
 * @Description: 登录、登出api
 */
import { requestOfGet, requestOfPost, requestOfPut } from '../utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'

// 登录
export function login(param) {
  return requestOfPost(`${baseUrl}account/login`, param)
}

// 静默登录
export function  silentLogin(param) {
  return requestOfPost(`${baseUrl}account/login/slient`, param)
}

// 测试获取AES加密后的手机号
export function testGetAESPhone() {
  return requestOfGet(`${baseUrl}account/encrypt`, { phone: '13612345678' })
}

// 登出
export function logOut(param) {
  return requestOfGet(`${baseUrl}account/logout`, param)
}

// 注册分销员
export function register(param) {
  return requestOfPut(`${baseUrl}distributor`, param)
}

// 获取短信验证码
export function getMsCode(param) {
  return requestOfGet(`${baseUrl}account/sendsmscode`, param)
}

// 获取消费者详情
export function getConsumerInfo(param) {
  return requestOfGet(`${baseUrl}account/info`, param)
}

// 修改消费者详情
export function putConsumerInfo(param) {
  return requestOfPut(`${baseUrl}account/info`, param)
}

// 修改消费者手机号
export function putChangePhone(param) {
  return requestOfPut(`${baseUrl}account/changephone`, param)
}

// 获取分销员详情
export function getDistributorInfo(param) {
  return requestOfGet(`${baseUrl}distributor`, param)
}

// 获取我的团员入团记录
export function getDistributorMemberList(param) {
  return requestOfGet(`${baseUrl}distributor/invite`, param)
}

// 获取我的提现记录
export function getDistributorWithdrawList(param) {
  return requestOfGet(`${baseUrl}distributor/withdraw`, param)
}

// 获取openid
export function getOpenId(param) {
  return requestOfGet(`${baseUrl}wrapper/oauth/${param}`)
}

// 获取用户订阅信息
export function getUserInfo(param) {
  return requestOfGet(`${baseUrl}wrapper/userinfo?openId=${param.openId}`)
}
// 是否授权了昵称 头像信息
export function getUserIsAuth(param) {
  return requestOfGet(`${baseUrl}wrapper/isauth`)
}
export function setUserWxAuth(param) {
  return requestOfPut(`${baseUrl}permission/save`,param)
}



